import { useQuery } from '@tanstack/react-query'
import { getSlideAnnouncement } from '../../services'
import { SlideAnnouncementQueryKeys } from '@/modules/client-setting/keys'
import { UseBaseQueryOptions } from '@/core/api/type'
import { GetSlideAnnouncementResponse } from '@/modules/client-setting/type'

export default function useQueryGetSlideAnnouncement(
	props?: UseBaseQueryOptions<GetSlideAnnouncementResponse>,
) {
	return useQuery({
		queryKey: [SlideAnnouncementQueryKeys.GetSlideAnnouncement],
		queryFn: getSlideAnnouncement,
		staleTime: 5 * 60 * 1000, // 5 minutes
		...props,
	})
}
